function MonitorIcon({
  size = 20,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M3.33337 3.33317C2.87314 3.33317 2.50004 3.70627 2.50004 4.1665V12.4998C2.50004 12.9601 2.87314 13.3332 3.33337 13.3332H16.6667C17.1269 13.3332 17.5 12.9601 17.5 12.4998V4.1665C17.5 3.70627 17.1269 3.33317 16.6667 3.33317H3.33337ZM0.833374 4.1665C0.833374 2.78579 1.95266 1.6665 3.33337 1.6665H16.6667C18.0474 1.6665 19.1667 2.78579 19.1667 4.1665V12.4998C19.1667 13.8805 18.0474 14.9998 16.6667 14.9998H3.33337C1.95266 14.9998 0.833374 13.8805 0.833374 12.4998V4.1665Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.83337 17.4998C5.83337 17.0396 6.20647 16.6665 6.66671 16.6665H13.3334C13.7936 16.6665 14.1667 17.0396 14.1667 17.4998C14.1667 17.9601 13.7936 18.3332 13.3334 18.3332H6.66671C6.20647 18.3332 5.83337 17.9601 5.83337 17.4998Z'
          fill='currentColor'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M9.99996 13.3335C10.4602 13.3335 10.8333 13.7066 10.8333 14.1668V17.5002C10.8333 17.9604 10.4602 18.3335 9.99996 18.3335C9.53972 18.3335 9.16663 17.9604 9.16663 17.5002V14.1668C9.16663 13.7066 9.53972 13.3335 9.99996 13.3335Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default MonitorIcon;
